// 统一的权限配置文件

// 角色定义
export const ROLES = {
  STUDENT: 1,
  TEACHER: 2,
  ADMIN: 3
};

// 路由权限配置 - 键为路由路径，值为允许访问的角色ID数组
export const ROUTE_PERMISSIONS = {
  '/navigate': [ROLES.STUDENT, ROLES.TEACHER, ROLES.ADMIN], // 学生、教师、管理员
  '/examL': [ROLES.STUDENT], // 学生
  '/examP': [ROLES.STUDENT], // 学生
  '/examA': [ROLES.STUDENT], // 学生
  '/examM': [ROLES.TEACHER], // 教师
  '/hallV': [ROLES.TEACHER], // 教师
  '/monitorV': [ROLES.TEACHER],//教师
  '/fixedV': [ROLES.TEACHER], // 教师
  '/bankV': [ROLES.TEACHER], // 教师
  '/questionM': [ROLES.TEACHER], // 教师
  '/scoreQ': [ROLES.STUDENT], // 学生
  '/scoreD': [ROLES.STUDENT], // 学生
  '/errorA': [ROLES.STUDENT],
  '/reviewP': [ROLES.TEACHER], // 教师
  '/paperG': [ROLES.TEACHER], // 教师
  '/scoreA': [ROLES.TEACHER], // 教师
  '/studentM': [ROLES.TEACHER], // 教师
  '/userM': [ROLES.ADMIN], // 管理员
  '/safeL': [ROLES.ADMIN], // 管理员
  '/dataC': [ROLES.ADMIN], // 管理员
  '/dataS': [ROLES.ADMIN], // 管理员
  '/myI':[ROLES.STUDENT,ROLES.TEACHER,ROLES.ADMIN],
  '/authV':[ROLES.TEACHER,ROLES.ADMIN],
};

// 菜单配置，包含每个菜单项的权限信息（一级目录结构）
export const MENU_CONFIG = [
  {index: "/navigate", title: "快捷导航", icon: "House"},
  {index: "/examL", title: "考试列表", icon: "Collection"},
  {index: "/examM", title: "考试管理", icon: "Edit"},
  {index: "/hallV", title: "考场管理", icon: "Edit"},
  {index: "/monitorV", title: "监控大屏", icon: "Edit"},
  {index: "/bankV", title: "题库管理", icon: "FolderOpened"},
  {index: "/questionM", title: "题目管理", icon: "Document"},
  {index: "/scoreQ", title: "成绩查询", icon: "Search"},
  {index: "/errorA", title: "错题分析", icon: "Search"},
  {index: "/reviewP", title: "评阅试卷", icon: "Notebook"},
  {index: "/scoreA", title: "成绩分析", icon: "Odometer"},
  {index: "/studentM", title: "学生管理", icon: "Avatar"},
  {index: "/userM", title: "用户管理", icon: "User"},
  {index: "/safeL", title: "安全日志", icon: "Lock"},
  {index: "/dataS", title: "数据合规", icon: "Lock"},
  {index: "/dataC", title: "数据统计", icon: "Printer"},
  {index: "/myI", title: "个人信息", icon: "UserFilled"},
];

// 辅助函数：根据路由路径获取允许的角色
export const getRolesForRoute = (path) => {
  return ROUTE_PERMISSIONS[path] || [];
};
